import { delay } from 'lodash';
import { Colors } from '../consts/Colors.js';
import { tags } from '../consts/Tags.js';
import ButtonImageSliced from './ButtonImageSliced.js';

export default class ScreenMaker extends Phaser.GameObjects.Container {
    constructor(scene, data) {
        super(scene, 0, 0, []);
        scene.add.existing(this);
        this.scene = scene;
        this.data = data;


        this.nextBtn = new ButtonImageSliced(this.scene, 1710, 990, 320, 80, "bouton", "Suivant")

        this.add(this.nextBtn)
        this.nextBtn.setClickFunction(() => {
            this.nextStep()
        })
        this.previewBtn = new ButtonImageSliced(this.scene, 220, 990, 320, 80, "bouton", "Précédent")
        this.add(this.previewBtn)
        this.previewBtn.setClickFunction(() => {
            this.previousStep()
        })
        if (this.scene.step === 0) {
            this.previewBtn.setAlpha(0);
        }

    }

    nextStep() {
        switch (this.scene.step) {
            case 0:
                this.secondScreen();
                this.previewBtn.setAlpha(1);
                break;
            case 1:

                this.thirdScreen();
                break;
            case 2:

                this.fourthScreen();
                break;
            case 3:

                this.fifthScreen();
                break;
            case 4:

                this.sixthScreen();
                break;
            case 5:

                this.seventhScreen();
                break;
            case 6:

                this.heightScreen();
                break;
            case 7:

                this.ninethScreen();
                break;
            case 8:

                this.tenthScreen();
                this.scene.btn1.setClosedAndDisable()
                this.scene.btn2.setDone();
                this.scene.btn2.setLocked()
                break;
            case 9:

                this.scene.tweens.add({
                    targets: [this.scene.mainContainer, this.scene.btn3, this.scene.btn4],
                    alpha: 0,
                    duration: 500,
                    ease: 'Power2',
                    onComplete: () => {
                        this.eleventhScreen();
                        this.nextBtn.setTextContent("Terminer");
                    }
                })
                break
            case 10:

                if (this.scene.game.data.level <= 5) {
                    this.scene.game.data.level = 6
                }
                // this.scene.scene.restart()
                this.scene.btn1.setAlpha(0)
                this.scene.btn2.setAlpha(0)
                this.scene.scene.start('Menu')
                break
        }
    }
    previousStep() {
        switch (this.scene.step) {
            // case 1:

            //     this.firstScreen();
            //     break;
            case 2:

                this.secondScreen();
                break;
            case 3:

                this.thirdScreen();
                break;
            case 4:

                this.fourthScreen();
                break;
            case 5:

                this.fifthScreen();
                break;
            case 6:

                this.sixthScreen();
                break;
            case 7:

                this.seventhScreen();
                break;
            case 8:

                this.heightScreen();
                break;
            case 9:

                this.ninethScreen();
                break;
            case 10:
                this.nextBtn.setTextContent("Suivant");
                // this.nextBtn.setTextContent("Suivant");
                // this.tenthScreen();
                this.firstScreen()
                // this.endBtn.destroy();
                // this.backBtn.destroy();
                this.scene.tweens.add({
                    targets: [this.scene.btn3, this.scene.btn4],
                    alpha: 1,
                    duration: 500,
                    ease: 'Power2',
                    onComplete: () => {
                        this.scene.btn1.setUnlocked()
                        this.scene.btn2.setUnlocked()
                        this.scene.btn3.setUnlocked()
                        this.scene.btn4.setUnlocked()

                    }
                })
                break;
        }

    }


    screenApparition() {
        console.log(this.scene.step)
        this.scene.playSound('whoosh');
        this.scene.tweens.add({
            targets: this.scene.mainContainer,
            x: 730,
            duration: 500,
            ease: 'Power2',
            onComplete: () => {
                this.scene.tweens.add({
                    targets: this.nextBtn,
                    angle: { from: -5, to: 5 },
                    yoyo: true,
                    delay: 2000,
                    repeat: 4,
                    duration: 50,
                    ease: 'Sine.easeInOut',
                    onComplete: () => {
                        this.nextBtn.angle = 0;
                    }
                })
            }
        })
    }

    screenDisparition(container) {
        console.log("disparition", this.scene.mainContainer, container)
        this.scene.tweens.add({
            targets: this.scene.mainContainer,
            x: 2000,
            duration: 500,
            ease: 'Power2',
            onComplete: () => {
                this.scene.mainContainer.destroy();
                this.scene.mainContainer = container;
                this.screenApparition()
            }
        })
    }

    firstScreen() {
        this.scene.step = 0;
        if (this.scene.mainContainer !== undefined) {
            this.scene.mainContainer.destroy();
        }
        if (this.scene.btn1.isDone) {
            this.scene.btn1.setClosed()
        }
        this.previewBtn.setAlpha(0);
        this.scene.btn1.setUnlocked();
        this.firstContainer = this.scene.add.container(2000, 180);
        this.scene.mainContainer = this.firstContainer;
        let txt1 = this.scene.createTextElement(0, 0, this.data.screen1.txt1);
        this.firstContainer.add(txt1);

        let txt2 = this.scene.createTextElement(0, 70, this.data.screen1.txt2);
        this.firstContainer.add(txt2);

        let txt3 = this.scene.createTextElement(0, 140, this.data.screen1.txt3);
        this.firstContainer.add(txt3);

        // let txt4 = this.scene.createTextElement(0, 646, this.data.screen1.txt4);
        // this.firstContainer.add(txt4);

        let illu = this.scene.add.image(40, 232, "b2Screen1").setOrigin(0);
        this.firstContainer.add(illu);
        this.screenApparition()
        return this.firstContainer;
    }

    secondScreen() {
        this.scene.step = 1;
        this.scene.btn1.setOpened();
        if (this.scene.btn2.isDone) {
            this.scene.btn2.setDone();
        }

        this.previewBtn.setAlpha(1);
        this.secondContainer = this.scene.add.container(2000, 400);
        let title = this.scene.createTextElement(0, 0, this.data.screen2.title);
        this.secondContainer.add(title);

        let txt1 = this.scene.createTextElement(50, 60, this.data.screen2.txt1);
        this.secondContainer.add(txt1);

        let txt2 = this.scene.createTextElement(0, 175, this.data.screen2.txt2);
        this.secondContainer.add(txt2);

        let txt3 = this.scene.createTextElement(0, 295, this.data.screen2.txt3);
        this.secondContainer.add(txt3);

        let txt4 = this.scene.createTextElement(0, 325, this.data.screen2.txt4);
        this.secondContainer.add(txt4);

        // let txt5 = this.scene.createTextElement(150, 406, this.data.screen2.txt5);
        // this.secondContainer.add(txt5);

        let illuA = this.scene.add.image(-50, 55, "b2Screen2A").setOrigin(0);
        this.secondContainer.add(illuA);

        // let illuB = this.scene.add.image(0, 358, "b2Screen2B").setOrigin(0);
        // this.secondContainer.add(illuB);
        this.screenDisparition(this.secondContainer)


        return this.secondContainer;

    }

    thirdScreen() {
        this.scene.step = 2;
        // Reset all txtBtns to unlocked if they are done, then set the active one
        this.scene.btn1.allTxtBtns.forEach(btn => {
            if (btn.isDone) {
                btn.setUnlocked();
            }
        })
        this.scene.btn1.txtBtn1.setActif();
        this.scene.btn1.txtBtn2.setUnlocked();
        this.thirdContainer = this.scene.add.container(2000, 400);
        let text1 = this.scene.createTextElement(0, 0, this.data.screen3.txt1);
        this.thirdContainer.add(text1);

        let text2 = this.scene.createTextElement(0, 216, this.data.screen3.txt2);
        this.thirdContainer.add(text2);

        let text3 = this.scene.createTextElement(0, 250, this.data.screen3.txt3);
        this.thirdContainer.add(text3);

        let text4 = this.scene.createTextElement(0, 460, this.data.screen3.txt4);
        this.thirdContainer.add(text4);

        this.scene.createBulletList(this.data.screen3.bulletList1, 60, 40, this.thirdContainer)
        this.scene.createBulletList(this.data.screen3.bulletList2, 60, 290, this.thirdContainer)

        let illuA = this.scene.add.image(-50, 55, "b2Screen2A").setOrigin(0);
        this.thirdContainer.add(illuA);
        let illuB = this.scene.add.image(498, 281, "b2Screen3").setOrigin(0);
        this.thirdContainer.add(illuB);
        this.screenDisparition(this.thirdContainer)
        return this.thirdContainer;
    }

    fourthScreen() {
        this.scene.step = 3;
        this.fourthContainer = this.scene.add.container(2000, 400);
        // Reset all txtBtns to unlocked if they are done, then set the active one
        this.scene.btn1.allTxtBtns.forEach(btn => {
            if (btn.isDone) {
                btn.setUnlocked();
            }
        })
        this.scene.btn1.txtBtn2.setActif();
        this.scene.btn1.txtBtn3.setUnlocked();
        // this.scene.btn1.allTxtBtns.forEach(btn => {
        //     if (btn.isLock === false && btn !== this.scene.btn1.txtBtn2) {
        //         btn.setUnlocked();
        //     }
        // })
        let text1 = this.scene.createTextElement(0, 0, this.data.screen4.txt1);
        this.fourthContainer.add(text1)
        let text2 = this.scene.createTextElement(0, 137, this.data.screen4.txt2);
        this.fourthContainer.add(text2)

        this.scene.createBulletList(this.data.screen4.bulletList1, 60, 50, this.fourthContainer)
        this.scene.createBulletList(this.data.screen4.bulletList2, -30, 400, this.fourthContainer)
        this.scene.createBulletList(this.data.screen4.bulletList3, 360, 400, this.fourthContainer)
        this.scene.createBulletList(this.data.screen4.bulletList4, 765, 400, this.fourthContainer)



        let illuA = this.scene.add.image(-50, 20, "b2Screen2A").setOrigin(0);
        this.fourthContainer.add(illuA);
        let illuB = this.scene.add.image(-50, 200, "b2Screen4").setOrigin(0);
        this.fourthContainer.add(illuB);
        this.screenDisparition(this.fourthContainer)

        return this.fourthContainer;

    }

    fifthScreen() {
        this.scene.step = 4;
        this.scene.btn2.setUnlocked()
        
        // Reset all txtBtns to unlocked if they are done, then set the active one
        this.scene.btn1.allTxtBtns.forEach(btn => {
            if (btn.isDone) {
                btn.setUnlocked();
            }
        })
        this.scene.btn1.txtBtn3.setActif();
        
        if (this.scene.btn1.state !== "opened") {
            this.scene.btn1.setOpened(6);
        }
        
        this.fifthContainer = this.scene.add.container(2000, 400);
        let text1 = this.scene.createTextElement(0, 0, this.data.screen5.txt1);
        this.fifthContainer.add(text1)
        let text2 = this.scene.createTextElement(0, 208, this.data.screen5.txt2);
        this.fifthContainer.add(text2)
        let text3 = this.scene.createTextElement(360, 230, this.data.screen5.txt3);
        this.fifthContainer.add(text3)
        let text4 = this.scene.createTextElement(765, 230, this.data.screen5.txt4);
        this.fifthContainer.add(text4)

        this.scene.createBulletList(this.data.screen5.bulletList1, 60, 45, this.fifthContainer, true, 0)
        this.scene.createBulletList(this.data.screen5.bulletList2, -30, 330, this.fifthContainer)
        this.scene.createBulletList(this.data.screen5.bulletList3, 360, 330, this.fifthContainer, true, 0)
        this.scene.createBulletList(this.data.screen5.bulletList4, 765, 330, this.fifthContainer)


        let illuA = this.scene.add.image(-50, 55, "b2Screen2A").setOrigin(0);
        this.fifthContainer.add(illuA);
        let illuB = this.scene.add.image(80, 355, "b2Screen5").setOrigin(0).setScale(0.7);
        this.fifthContainer.add(illuB);
        this.screenDisparition(this.fifthContainer)
        return this.fifthContainer;
    }

    sixthScreen() {
        this.scene.step = 5;
        this.scene.btn3.setUnlocked()
        this.scene.btn2.setActif()
        this.scene.btn1.setDone()
        this.scene.btn1.setClosed()
        this.sixthContainer = this.scene.add.container(2000, 175);
        let title = this.scene.createTextElement(0, 0, this.data.screen6.title);
        this.sixthContainer.add(title)
        let text1 = this.scene.createTextElement(50, 65, this.data.screen6.txt1);
        this.sixthContainer.add(text1)
        let text2 = this.scene.createTextElement(0, 153, this.data.screen6.txt2);
        this.sixthContainer.add(text2)
        let text3 = this.scene.createTextElement(0, 210, this.data.screen6.txt3);
        this.sixthContainer.add(text3)

        this.scene.createBulletList(this.data.screen6.bulletList1, 60, 260, this.sixthContainer)

        let illuA = this.scene.add.image(-50, 40, "b2Screen2A").setOrigin(0);
        this.sixthContainer.add(illuA);
        this.screenDisparition(this.sixthContainer)
        return this.sixthContainer;
    }

    seventhScreen() {
        if (this.scene.btn4.state == "opened") {
            this.scene.btn4.setClosed();
        }
        this.scene.step = 6;
        this.scene.btn2.setDone()
        this.scene.btn3.setActif()
        this.scene.btn4.setUnlocked()
        this.seventhContainer = this.scene.add.container(2000, 175);

        let title = this.scene.createTextElement(0, 0, this.data.screen7.title);
        this.seventhContainer.add(title)
        let text1 = this.scene.createTextElement(50, 65, this.data.screen7.txt1);
        this.seventhContainer.add(text1)
        let text2 = this.scene.createTextElement(0, 210, this.data.screen7.txt2);
        this.seventhContainer.add(text2)

        this.scene.createBulletList(this.data.screen7.bulletList1, 60, 255, this.seventhContainer)

        let illuA = this.scene.add.image(-50, 40, "b2Screen2A").setOrigin(0);
        this.seventhContainer.add(illuA);
        this.screenDisparition(this.seventhContainer)
        return this.seventhContainer;
    }

    heightScreen() {
        this.scene.step = 7;
        this.scene.btn3.setDone()
        this.scene.btn4.setOpened()
        this.heightContainer = this.scene.add.container(2000, 180);
        let title = this.scene.createTextElement(0, 0, this.data.screen8.title);
        this.heightContainer.add(title)
        let text1 = this.scene.createTextElement(50, 65, this.data.screen8.txt1);
        this.heightContainer.add(text1)
        let text2 = this.scene.createTextElement(0, 150, this.data.screen8.txt2);
        this.heightContainer.add(text2)

        let illuA = this.scene.add.image(-50, 35, "b2Screen2A").setOrigin(0);
        this.heightContainer.add(illuA);
        this.screenDisparition(this.heightContainer)
        return this.heightContainer;
    }

    ninethScreen() {
        this.scene.step = 8;
        this.ninethContainer = this.scene.add.container(2000, 180);
        this.scene.btn4.txtBtn1.setActif();
        this.scene.btn4.txtBtn2.setUnlocked();
        let text1 = this.scene.createTextElement(0, 0, this.data.screen9.txt1);
        this.ninethContainer.add(text1)
        let text2 = this.scene.createTextElement(0, 150, this.data.screen9.txt2);
        this.ninethContainer.add(text2)
        let text3 = this.scene.createTextElement(0, 400, this.data.screen9.txt3);
        this.ninethContainer.add(text3)
        let text4 = this.scene.createTextElement(0, 430, this.data.screen9.txt4);
        this.ninethContainer.add(text4)

        this.scene.createBulletList(this.data.screen9.bulletList1, 60, 50, this.ninethContainer)
        this.scene.createBulletList(this.data.screen9.bulletList2, 60, 255, this.ninethContainer)

        let illuA = this.scene.add.image(-50, 20, "b2Screen2A").setOrigin(0);
        this.ninethContainer.add(illuA);
        let illuB = this.scene.add.image(623, 229, "b2Screen9").setOrigin(0);
        this.ninethContainer.add(illuB);
        this.screenDisparition(this.ninethContainer)
        return this.ninethContainer;


    }

    tenthScreen() {
        this.scene.step = 9;
        // this.scene.nextBtn.setAlpha(1)
        this.nextBtn.setTextContent("Suivant");
        this.scene.btn4.txtBtn2.setActif();
        this.scene.btn4.txtBtn1.setUnlocked();
        this.tenthContainer = this.scene.add.container(2000, 180);
        let text1 = this.scene.createTextElement(0, 0, this.data.screen10.txt1);
        this.tenthContainer.add(text1)
        let text2 = this.scene.createTextElement(0, 150, this.data.screen10.txt2);
        this.tenthContainer.add(text2)

        this.scene.createBulletList(this.data.screen10.bulletList1, 60, 50, this.tenthContainer)
        this.scene.createBulletList(this.data.screen10.bulletList2, 60, 255, this.tenthContainer)

        let illuA = this.scene.add.image(-50, 20, "b2Screen2A").setOrigin(0);
        this.tenthContainer.add(illuA);
        let illuB = this.scene.add.image(445, 288, "b2Screen10").setOrigin(0);
        this.tenthContainer.add(illuB);
        this.screenDisparition(this.tenthContainer)
        return this.tenthContainer;


    }

    eleventhScreen() {
        this.scene.step = 10;
        this.scene.btn4.setClosed()
        this.scene.btn1.setLocked();
        this.scene.btn2.setLocked();
        this.scene.btn3.setAlpha(0);
        this.scene.btn4.setAlpha(0);
        this.nextBtn.setTextContent("Terminer");

        let targets1 = []
        let targets2 = []
        let targets3 = []
        this.eleventhContainer = this.scene.add.container(2000, 180);
        this.scene.mainContainer = this.eleventhContainer;
        this.scene.mainContainer.x = 730
        let title = this.scene.createTextElement(0, 0, this.data.screen11.title);
        this.eleventhContainer.add(title)


        let subTitle1 = this.scene.createTextElement(120, 180, this.data.screen11.subtitle1);
        this.eleventhContainer.add(subTitle1)
        let txt1 = this.scene.createTextElement(335, 134, this.data.screen11.txt1);
        this.eleventhContainer.add(txt1)
        let accolade1 = this.scene.add.image(252, 123, "accoladeA").setOrigin(0);
        this.eleventhContainer.add(accolade1);
        targets1.push(subTitle1, txt1, accolade1)
        targets1.forEach((target) => {
            target.setAlpha(0);
        })


        let subTitle2 = this.scene.createTextElement(120, 325, this.data.screen11.subtitle2);
        this.eleventhContainer.add(subTitle2)
        let accolade2 = this.scene.add.image(252, 307, "accoladeB").setOrigin(0);
        this.eleventhContainer.add(accolade2);
        let txt2 = this.scene.createTextElement(335, 325, this.data.screen11.txt2);
        this.eleventhContainer.add(txt2)
        targets2.push(subTitle2, txt2, accolade2)
        targets2.forEach((target) => {
            target.setAlpha(0);
        })

        let subTitle3 = this.scene.createTextElement(120, 484, this.data.screen11.subtitle3);
        this.eleventhContainer.add(subTitle3)
        let accolade3 = this.scene.add.image(252, 443, "accoladeC").setOrigin(0);
        this.eleventhContainer.add(accolade3);
        let txt3 = this.scene.createTextElement(335, 455, this.data.screen11.txt3);
        this.eleventhContainer.add(txt3)
        targets3.push(subTitle3, txt3, accolade3)
        targets3.forEach((target) => {
            target.setAlpha(0);
        })
        this.scene.playSound('pop');
        this.scene.tweens.add({
            targets: targets1,
            alpha: 1,
            delay: 200,
            duration: 500,
            ease: 'Power2',
            onComplete: () => {
                this.scene.playSound('pop');
                this.scene.tweens.add({
                    targets: targets2,
                    alpha: 1,
                    duration: 500,
                    ease: 'Power2',
                    onComplete: () => {
                        this.scene.playSound('pop');
                        this.scene.tweens.add({
                            targets: targets3,
                            alpha: 1,
                            duration: 500,
                            ease: 'Power2',
                            onComplete: () => {
                                
                            }
                        })
                    }
                })
            }
        })

        let illuA = this.scene.add.image(-560, 428, "b2Screen11").setOrigin(0);
        this.eleventhContainer.add(illuA);

        // this.screenDisparition(this.eleventhContainer)

        return this.eleventhContainer;
    }
}